export const projectName = 'evobet216.com'
export const projectStyledName = 'evobet216.com'
export const projectDomainName = 'evobet216.com'
export const projectKey = 'evobet216.com'

export const altenarBetHistoryUrl = 'https://dobets365.com/bet-history-frame'
export const newBCraftServicesUrl = 'https://new.bcraftservices.com'
export const sliderUrl = 'https://gcatg.com/services/content'
export const sliderImageBaseUrl = 'https://images.gcatg.com/media'

export const defaultCurrency = 'USD'

export const altenarScriptId = 'altenar-script'
export const betbyScriptId = 'betby-script'

// Pragmatic DGA
export const PRAGMATIC_DGA_WS_URL = 'dga.pragmaticplaylive.net'

export const PRAGMATIC_DGA_CASINO_ID = 'ppcdh00000006109'

export const EXTERNAL_LINKS = {
  // xSocial: 'https://x.com/evobet216',
  // telegram: 'https://t.me/evobet216',
  // whatsapp: 'https://wa.me/',
  // instagram: 'https://www.instagram.com/evobet216',
  // tiktok: 'https://www.tiktok.com/@evobet216',
}
